export default "__VITE_ASSET__DbwOK_dX__"